'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	_ = require('underscore'),
	sceneList = require('./storyboard-scene-list');

module.exports = function StoryboardModel(activeContentListener, storyboardAttrName, sceneAttrName) {
	let isInputEnabled,
		scenesForActiveStoryboard;

	const self = observable(this),
		rebuildScenesForActiveStoryboard = function () {
			const storyboardName = self.getActiveStoryboardName(),
				result = [],
				getTitle = function (idea, sceneType) {
					let result = idea.title;
					if (sceneType === 'with-children') {
						_.each(idea.sortedSubIdeas(), function (subIdea) {
							result = result + '\n- ' + subIdea.title;
						});
					}
					return result;
				};
			if (!storyboardName) {
				scenesForActiveStoryboard = sceneList(result);
				return;
			}
			activeContentListener.getActiveContent().traverse(function (idea) {
				const scenes = idea.getAttr(sceneAttrName);
				if (scenes) {
					_.each(scenes, function (scene) {
						const sceneIndex = parseFloat(scene.storyboards[storyboardName]);
						let converted, icon;
						if (sceneIndex) {
							converted = {ideaId: idea.id, title: getTitle(idea, scene.type), index: sceneIndex};
							icon = idea.getAttr('icon');
							if (icon) {
								converted.image = icon;
							}
							result.push(converted);
						}
					});
				}
			});
			scenesForActiveStoryboard = sceneList(_.sortBy(result, 'index'));
		},
		indexMatches = function (idx1, idx2) {
			return Math.abs(idx1 - idx2) < 0.0001;
		},
		findMaxIndex = function (arr) {
			let maxIndex;
			if (!arr) {
				return 0;
			}
			maxIndex = arr.length;
			_.each(arr, function (boardName) {
				const match = boardName.match(/^Storyboard ([1-9]+)/),
					idx = (match && match.length > 1 && parseFloat(match[1])) || 0;
				if (idx > maxIndex) {
					maxIndex = idx;
				}
			});
			return maxIndex;
		},
		getSceneDelta = function (oldScenes, newScenes) {
			const result = {removed: [], added: [], contentUpdated: []};
			sceneList(oldScenes);
			sceneList(newScenes);
			_.each(oldScenes, function (oldScene) {
				const newScene = newScenes && newScenes.findScene(oldScene);
				if (!newScene) {
					result.removed.push(oldScene);
				} else if (newScene.title !== oldScene.title || !_.isEqual(newScene.image, oldScene.image)) {
					result.contentUpdated.push(newScene);
				}
			});
			_.each(newScenes, function (newScene) {
				const oldScene  = oldScenes && oldScenes.findScene(newScene);
				if (!oldScene) {
					result.added.push(newScene);
				}

			});
			if (result.added.length === 1 && result.removed.length === 1 && result.contentUpdated.length === 0 &&
					result.added[0].ideaId === result.removed[0].ideaId) {
				return { moved: {from: result.removed[0], to: result.added[0]} };
			}
			return result;
		},
		dispatchDifferences = function (oldScenes) {
			const delta = getSceneDelta(oldScenes, scenesForActiveStoryboard);
			_.each(delta.removed, function (scene) {
				self.dispatchEvent('storyboardSceneRemoved', scene);
			});
			_.each(delta.added, function (scene) {
				self.dispatchEvent('storyboardSceneAdded', scene);
			});
			_.each(delta.contentUpdated, function (scene) {
				self.dispatchEvent('storyboardSceneContentUpdated', scene);
			});
			if (delta.moved) {
				self.dispatchEvent('storyboardSceneMoved', delta.moved);
			}
			if (!_.isEmpty(delta.moved) || !_.isEmpty(delta.removed) || !_.isEmpty(delta.added)) {
				self.dispatchEvent('storyboardChanged');
			}
		},
		onActiveContentChanged = function () {
			const oldScenes = scenesForActiveStoryboard;
			if (!isInputEnabled) {
				return;
			}
			rebuildScenesForActiveStoryboard();
			dispatchDifferences(oldScenes);
		};
	self.setInputEnabled = function (isEnabled) {
		isInputEnabled = isEnabled;
		if (isEnabled) {
			onActiveContentChanged();
		}
		self.dispatchEvent('inputEnabled', isEnabled);
	};
	self.getInputEnabled = function () {
		return isInputEnabled;
	};
	self.getActiveStoryboardName = function () {
		const content = activeContentListener && activeContentListener.getActiveContent(),
			list = content && content.getAttr(storyboardAttrName);
		if (list && list.length > 0) {
			return list[0];
		}
	};
	self.createStoryboard = function () {
		const content = activeContentListener && activeContentListener.getActiveContent(),
			boards = (content && content.getAttr(storyboardAttrName)) || [],
			maxIndex = findMaxIndex(boards),
			name = 'Storyboard ' + (maxIndex + 1);
		if (!content) {
			return;
		}
		boards.push(name);
		content.updateAttr(content.id, storyboardAttrName, boards);
		return name;
	};
	self.nextSceneIndex = function () {
		return scenesForActiveStoryboard && scenesForActiveStoryboard.nextSceneIndex();
	};
	self.updateSceneIndex = function (sceneToMove, newIndex, storyboardName) {
		const scenesForIdea = self.getScenesForNodeId(sceneToMove.ideaId);
		_.each(scenesForIdea, function (scene) {
			if (scene.storyboards && scene.storyboards[storyboardName] && scene.storyboards[storyboardName] === sceneToMove.index) {
				scene.storyboards[storyboardName] = newIndex;
			}
		});
		self.setScenesForNodeId(sceneToMove.ideaId, scenesForIdea);
		return _.extend({}, sceneToMove, {index: newIndex});
	};
	self.getScenesForNodeId = function (nodeId) {
		const scenes = activeContentListener.getActiveContent().getAttrById(nodeId, sceneAttrName) || [];
		return JSON.parse(JSON.stringify(scenes));
	};
	self.setScenesForNodeId = function (nodeId, scenes) {
		activeContentListener.getActiveContent().updateAttr(nodeId, sceneAttrName, scenes);
	};
	self.scenesMatch = function (scene1, scene2) {
		if (!scene1 || !scene2) {
			return false;
		}
		if (scene1.ideaId !== scene2.ideaId) {
			return false;
		}
		if (scene1.index !== scene2.index) {
			return false;
		}
		return true;
	};
	self.rebalance = function (scenesOfInterest) {
		const scenesToReturn = [],
			storyboard = self.getActiveStoryboardName();
		let nextIndex = 1;
		//TODO: use array.forEach?
		_.each(scenesForActiveStoryboard, function (scene) {
			const sceneOfInterest = _.find(scenesOfInterest, function (sceneOfInterest) {
					return self.scenesMatch(scene, sceneOfInterest);
				}),
				indexOfInterest = sceneOfInterest !== undefined ? _.indexOf(scenesOfInterest, sceneOfInterest) : -1,
				reIndexedScene = self.updateSceneIndex(scene, nextIndex, storyboard);
			nextIndex++;
			if (indexOfInterest >= 0) {
				scenesToReturn[indexOfInterest] = reIndexedScene;
			}
		});
		return scenesToReturn;
	};
	self.rebalanceAndApply = function (scenesOfInterest, applyFunc) {
		const activeContent = activeContentListener.getActiveContent();
		activeContent.batch(function () {
			const scenesOfInterestAfter = self.rebalance(scenesOfInterest);
			onActiveContentChanged();
			applyFunc(scenesOfInterestAfter);
		});
	};
	self.insertionIndexAfter = function (sceneToInsertAfter) {
		const indexToInsertAtStart = function () {
				let result;
				if (scenesForActiveStoryboard.length === 0) {
					return false;
				} else {
					result = scenesForActiveStoryboard[0].index / 2;
					if (indexMatches(result, scenesForActiveStoryboard[0].index)) {
						return false; /* rebalance required */
					} else {
						return result;
					}
				}
			},
			betweenThisAndNext = function (sceneToInsertAfterPosition) {
				const nextIndex = scenesForActiveStoryboard[sceneToInsertAfterPosition + 1].index,
					result = (sceneToInsertAfter.index + nextIndex) / 2;
				if (indexMatches(result, nextIndex) || indexMatches(result, sceneToInsertAfter.index)) {
					return false;
				}
				return result;
			},
			indexToInsertAfterStart = function () {
				//TODO: use array.find?
				const sceneToInsertAfterPosition = _.indexOf(scenesForActiveStoryboard, _.find(scenesForActiveStoryboard, function (scene) {
					return scene.ideaId === sceneToInsertAfter.ideaId && scene.index === sceneToInsertAfter.index;
				}));
				if (sceneToInsertAfterPosition < 0) {
					return false;
				}
				if (sceneToInsertAfterPosition === scenesForActiveStoryboard.length - 1) {
					return sceneToInsertAfter.index + 1;
				}
				return betweenThisAndNext(sceneToInsertAfterPosition);
			};
		if (!sceneToInsertAfter) {
			return indexToInsertAtStart();
		}
		return indexToInsertAfterStart();
	};
	self.insertionIndexBefore = function (sceneToInsertBefore) {
		const betweenThisAndPrevious = function (sceneIndex) {
				const previousIndex = sceneIndex === 0 ? 0 : scenesForActiveStoryboard[sceneIndex - 1].index,
					result = (sceneToInsertBefore.index + previousIndex) / 2;
				if (indexMatches(result, previousIndex) || indexMatches(result, sceneToInsertBefore.index)) {
					return false;
				}
				return result;
			},
			sceneToInsertBeforePosition = sceneToInsertBefore && scenesForActiveStoryboard.indexOfScene(sceneToInsertBefore);

		if (!sceneToInsertBefore) {
			return false;
		}
		if (sceneToInsertBeforePosition < 0) {
			return false;
		}
		return betweenThisAndPrevious(sceneToInsertBeforePosition);
	};
	self.getScenes = function () {
		if (!isInputEnabled) {
			rebuildScenesForActiveStoryboard();
		}
		return scenesForActiveStoryboard;
	};
	activeContentListener.addListener(onActiveContentChanged);
};


